module.exports = __webpack_public_path__ + "img/desserts.55096e9f.svg";